import ButtonTile from './ButtonTile.vue';
import WindTile from './WindTile.vue';
import WaterDepthTile from './WaterDepthTile.vue';
import TemperatureTile from './TemperatureTile.vue';
import GnssTile from './GnssTile.vue';
import HeadingTile from './HeadingTile.vue';
import RudderTile from './RudderTile.vue';
import AtmosphericPressureTile from './AtmosphericPressureTile.vue';

import FluidTileComponents from './fluid';
const TileComponents = {
    // ButtonTile, Ignored for now
    WindTile,
    WaterDepthTile,
    TemperatureTile,
    GnssTile,
    HeadingTile,
    RudderTile,
    AtmosphericPressureTile,
    ...FluidTileComponents,
};
export default TileComponents;
